import { withStyles } from 'material-ui';
import { MenuItem } from 'material-ui/Menu/index';
import TextField from 'material-ui/TextField/TextField';
import React from 'react';
import { translate } from 'react-i18next';
import { handleEroskiDestinationChangeFactory } from '../CommonFunctions';
import SelectNative from '../../../ui/SelectNative';

const styles = theme => ({
    textField: {
        width: '100%',
    },
    inputLabel: {
        overflow: 'hidden',
        whiteSpace: 'nowrap'
    }
});

class ExclusiveSearchForm extends React.Component {

    constructor(props) {
        super(props);
        this.state = { value: props.value };
    }

    handleEroskiDestinationChange = destinationId => {
        this.setState({ value: destinationId });
        handleEroskiDestinationChangeFactory(this.props.parent)(destinationId);
    };

    render() {
        const { exclusiveDestinations, t, value } = this.props;
        return (
            <SelectNative id={'exclusiveFormsSelect'}
                label={t('HOME.DESTINATION')}
                labelProp="name" codeProp="_id"
                selection={value ? value : null}
                onChange={(val) => {
                    this.handleEroskiDestinationChange(val);
                }}
                options={exclusiveDestinations} />
        );
    }

}

export default translate('translations')(withStyles(styles)(ExclusiveSearchForm));


// WEBPACK FOOTER //
// ./src/components/SearchContent/ExclusiveSearchForms/ExclusiveSearchForm.b2bweberoski.js